<template>
    <div class="detail">
        <div class="top-content main_content">
            <TopMenus v-model="activeIndex"></TopMenus>
        </div>
        <div class="banner-box">
            <div class="main_content banner-content">
                <div class="banner">
                    <el-carousel indicator-position="outside" arrow="always" height="338rem">
                        <el-carousel-item class="carousel-item">
                            <img src="./images/arrow.png" alt="img"/>
                        </el-carousel-item>
                        <el-carousel-item class="carousel-item">
                            <img src="./images/arrow.png" alt="img"/>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="info">
                    <div class="title">快麦<span class="other-color">DP458</span>系列云小票机</div>
                    <div class="sub-title">usb+来单真人语音+手动撕纸</div>
                    <div class="text">
                        通讯接口：usb<br/>
                        打印速度：90-120mm/S<br/>
                        打印宽度：48mm<br/>
                        适用：外卖、零售、餐饮等打印小票
                    </div>
                </div>
            </div>
        </div>
        <div v-if="activeIndex===0" class="content-bg1"></div>
        <div v-else-if="activeIndex===1" class="content-bg2"></div>
    </div>
</template>

<script>
import TopMenus from '@/views/printCenter/TopMenus.vue'

export default {
    name: "DP458",
    components: {TopMenus},
    data() {
        return {
            activeIndex: 0
        };
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../printCenter.scss";

.detail {
    .content-bg1 {
        height: 702rem;
        background: url("./images/arrow.png") center / 1920rem no-repeat;
    }

    .content-bg2 {
        height: 102rem;
        background: url("./images/arrow.png") center / 1920rem no-repeat;
    }
}
</style>
